$(function(){
    window.onload = function() {
        lightbox.option({
            'albumLabel': '%1/%2',
            'disableScrolling': true,
            'resizeDuration': 10,
            'fadeDuration': 250,
            'positionFromTop': 0
        })
        
        // IE11対応 元のページがtopにスクロールされてしまうので、その位置で画像を表示する
        var agent = window.navigator.userAgent.toLowerCase();
        if (agent.indexOf('trident/7') !== -1) {
        	var scroll = 0;
            $('[data-lightbox="group"]').click(function(){
            	scroll = $('html').scrollTop();
                $('body').addClass("fixed")
            });
            $(".lightboxOverlay,.lb-close,.lightbox").click(function(){
                $('body').removeClass("fixed")
                $('body,html').animate({scrollTop:scroll},0);
            });
        }
    };
});